import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoute, PublicRoute, BaseRoute } from './_config/RouteConfig';
import { navigateRoutes } from './_config/route';
import SignIn from './screens/Auth/SignIn';
import SignUp from './screens/Auth/SignUp';
import ForgotPassword from './screens/Auth/ForgotPassword';
import ResetPassword from './screens/Auth/ResetPassword';
import SavedContacts from './screens/SavedContacts';
import SavedCompanies from './screens/SavedCompanies';
import SavedUsers from './screens/SavedUsers';
import ViewContact from './screens/ViewContact';
import Support from './screens/Support';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BaseRoute />} />

        <Route path="/" element={<PublicRoute />}>
          <Route path={navigateRoutes.signIn} element={<SignIn />} />
          <Route path={navigateRoutes.signUp} element={<SignUp />} />
          <Route path={navigateRoutes.forgotPassword} element={<ForgotPassword />} />
          <Route path={navigateRoutes.resetPassword} element={<ResetPassword />} />
        </Route>

        <Route path="/" element={<PrivateRoute />}>
          <Route path={navigateRoutes.savedContacts} element={<SavedContacts />} />
          <Route path={navigateRoutes.savedCompanies} element={<SavedCompanies />} />
          <Route path={navigateRoutes.savedUsers} element={<SavedUsers />} />
          <Route path={navigateRoutes.viewContact} element={<ViewContact />} />
        </Route>

        <Route path="*" element={<Navigate replace to="/" />} />
        <Route path={navigateRoutes.support} element={<Support />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
